module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/es-abstract/helpers/isNaN.js
// module id = 636
// module chunks = 168707334958949